export const CONFIGURATOR_DEFAULT = 'configurator.default';
export const CONFIGURATOR_PLAYER_PLAN = 'configurator.playerPlan';
export const CONFIGURATOR_SINGLE_TRAINING = 'configurator.singleTraining';